export function reportWebVitals(name = "", value = "", event_category = "", event_label = "", params = {}) {
	console.log(params, 'params.>>>')
	const newParams = Object.assign({}, { value, event_category, event_label }, params);

	window.gtag("event", name, newParams);
}
